import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9bc64138"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_2 = { class: "nav-item" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "card mb-5" }
const _hoisted_7 = { class: "card-body py-4" }
const _hoisted_8 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_9 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "min-w-60px" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "" }
const _hoisted_24 = { class: "" }

import { ref, onMounted, watch, inject, computed } from "vue";
import {
  ApplicationType,
  ApplicationStatusType,
} from "@/core/types/ApplicationInfos";
import AccountService from "../services/AccountService";
import TimeShow from "@/components/TimeShow.vue";
import LoadingRing from "@/components/LoadingRing.vue";
import NoDataBox from "@/components/NoDataBox.vue";
import ApplicationDetailsPanel from "@/projects/tenant/modules/accounts/components/ApplicationDetailsPanel.vue";
import TableFooter from "@/components/TableFooter.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { useRoute, useRouter } from "vue-router";
import AccountDetail from "@/projects/tenant/modules/accounts/components/AccountDetail.vue";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
import wholesaleReferralDetail from "../components/wholesaleReferral/wholesaleReferralDetail.vue";
const enum TabStatus {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
  Completed = 4,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountActivities',
  setup(__props) {

const route = useRoute();
const isLoading = ref(false);
const applications = ref(Array<any>());

const accountDetailsPanelRef = ref<InstanceType<typeof AccountDetail>>();
const wholesaleReferralDetailRef =
  ref<InstanceType<typeof wholesaleReferralDetail>>();

// 显式指定 any 以避免注入类型不匹配导致的 TS 报错
const openConfirm =
  (inject<any>(TenantGlobalInjectionKeys.OPEN_CONFIRM_MODAL) as any) ||
  ((...args: any[]) => MsgPrompt.info(...args));

const changeTab = (tab: TabStatus) => {
  criteria.value.status =
    {
      [TabStatus.Pending]: ApplicationStatusType.AwaitingApproval,
      [TabStatus.Approved]: ApplicationStatusType.Approved,
      [TabStatus.Rejected]: ApplicationStatusType.Rejected,
      [TabStatus.Completed]: ApplicationStatusType.Completed,
    }[tab] ?? ApplicationStatusType.AwaitingApproval;
  fetchData(1);
};

// 解析当前路由对应的 activity 类型（原先依赖 route.params.type，但路由并未定义该 param，导致一直使用默认值）
const resolveActivityTypeKey = (): string => {
  const name = (route.name as string | undefined)?.toLowerCase() || "";
  if (name.includes("password")) return "password";
  if (name.includes("leverage")) return "leverage";
  // WholesaleActivity route name contains 'wholesaleactivity'
  if (name.includes("wholesale") && !name.includes("referral")) {
    return "wholesale";
  }
  if (name.includes("referral")) return "referral";
  // 兜底：从 path 最后一段再尝试
  const last = route.path.split("/").filter(Boolean).pop();
  if (["password", "leverage", "wholesale", "referral"].includes(last || "")) {
    return last as string;
  }
  return "leverage"; // 默认
};

const activityTypeKey = computed(resolveActivityTypeKey);

const getInitialCriteria = () => {
  const key = activityTypeKey.value;
  return {
    size: 10,
    page: 1,
    status: ApplicationStatusType.AwaitingApproval,
    types: [
      {
        password: ApplicationType.TradeAccountChangePassword,
        leverage: ApplicationType.TradeAccountChangeLeverage,
        wholesale: ApplicationType.WholeSaleAccount,
        referral: ApplicationType.WholesaleReferral,
      }[key] ?? ApplicationType.TradeAccountChangeLeverage,
    ],
  };
};

const criteria = ref<any>(getInitialCriteria());

const resetWholesaleApplication = async (_id: number) => {
  try {
    await AccountService.resetWholesaleApplication(_id);
    MsgPrompt.success("Reset successfully");
  } catch (e) {
    MsgPrompt.warning("Wholesale application has been reset");
  }
};

const openReverseBox = (applicationId: number) => {
  openConfirm(() =>
    AccountService.reverseApplicationsById(applicationId).then(() =>
      fetchData(1)
    )
  );
};

const showAccount = async (applicationSupplement: any) => {
  const accountUid =
    applicationSupplement?.AccountUid ?? applicationSupplement?.accountUid;

  const accountNumber =
    applicationSupplement?.AccountNumber ??
    applicationSupplement?.accountNumber;
  if (!accountNumber && !accountUid) {
    MsgPrompt.error("Account is not found");
    return;
  }

  const { data } = await AccountService.queryAccounts({
    uid: accountUid ?? accountNumber,
  });
  if (data.length === 0) {
    MsgPrompt.error("Account not found");
    return;
  }

  const account = data[0];

  accountDetailsPanelRef.value?.show(account.id, "infos", [] as any);
};

const applicationDetailsPanelRef =
  ref<InstanceType<typeof ApplicationDetailsPanel>>();

const showApplicationDetails = (applicationDetails: any) => {
  activityTypeKey.value === "referral"
    ? wholesaleReferralDetailRef.value?.show(applicationDetails)
    : applicationDetailsPanelRef.value?.show(applicationDetails);
};

const fetchData = async (_page: number = criteria.value.page) => {
  criteria.value.page = _page;
  try {
    isLoading.value = true;
    const res = await AccountService.queryApplications(criteria.value);
    criteria.value = res.criteria;
    applications.value = res.data.map((item: any) => ({
      ...item,
      user: {
        ...item.user,
        partyId: item.partyId,
      },
    }));
  } catch (e) {
    MsgPrompt.error(e);
  } finally {
    isLoading.value = false;
  }
};

const router = useRouter();

const handleBeforeClose = () => {
  const query = { ...route.query } as Record<string, any>;
  delete query.id;
  router.replace({
    name: route.name as string,
    params: route.params,
    query,
  });
};

watch(
  () => route.query.id,
  async () => {
    if (route.query.id) {
      await fetchData(1);
      openApplicationDetailsFromRoute();
    }
  }
);

const openApplicationDetailsFromRoute = () => {
  const applicationDetails = applications.value.find(
    (item) => item.id === Number(route.query.id)
  );
  if (applicationDetails) {
    showApplicationDetails(applicationDetails);
  }
};

// 监听路由 name（不同 activity 走不同静态路由，没有 params.type）
watch(
  () => route.name,
  () => {
    criteria.value = getInitialCriteria();
    fetchData(1);
  }
);

onMounted(async () => {
  criteria.value = getInitialCriteria();
  await fetchData(1);
  if (route.query?.id) {
    openApplicationDetailsFromRoute();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("a", {
          class: _normalizeClass([
          'nav-link text-active-primary pb-4',
          { active: criteria.value.status === TabStatus.Pending },
          { 'disabled opacity-50 pe-none': isLoading.value },
        ]),
          href: "#",
          "data-bs-toggle": "tab",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeTab(TabStatus.Pending)))
        }, _toDisplayString(_ctx.$t("status.pending")), 3)
      ]),
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("a", {
          class: _normalizeClass([
          'nav-link text-active-primary pb-4',
          { active: criteria.value.status === TabStatus.Approved },
          { 'disabled opacity-50 pe-none': isLoading.value },
        ]),
          href: "#",
          "data-bs-toggle": "tab",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeTab(TabStatus.Approved)))
        }, _toDisplayString(_ctx.$t("status.approved")), 3)
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("a", {
          class: _normalizeClass([
          'nav-link text-active-primary pb-4',
          { active: criteria.value.status === TabStatus.Rejected },
          { 'disabled opacity-50 pe-none': isLoading.value },
        ]),
          href: "#",
          "data-bs-toggle": "tab",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (changeTab(TabStatus.Rejected)))
        }, _toDisplayString(_ctx.$t("status.rejected")), 3)
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createElementVNode("a", {
          class: _normalizeClass([
          'nav-link text-active-primary pb-4',
          { active: criteria.value.status === TabStatus.Completed },
          { 'disabled opacity-50 pe-none': isLoading.value },
        ]),
          href: "#",
          "data-bs-toggle": "tab",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (changeTab(TabStatus.Completed)))
        }, _toDisplayString(_ctx.$t("status.completed")), 3)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_9, [
              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.client")), 1),
              _createElementVNode("th", _hoisted_11, [
                (activityTypeKey.value === 'referral')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t("fields.referral")), 1))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("fields.accountNo")), 1)
              ]),
              _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("fields.type")), 1),
              _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                _createVNode(LoadingRing)
              ]))
            : (!isLoading.value && applications.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
                  _createVNode(NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(applications.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_19, [
                        _createVNode(_component_UserInfo, {
                          user: item.user,
                          class: "me-2"
                        }, null, 8, ["user"])
                      ]),
                      _createElementVNode("td", _hoisted_20, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: ($event: any) => (showAccount(item.supplement))
                        }, _toDisplayString(item.supplement?.accountNumber ??
                item.supplement?.AccountNumber ??
                "View Details"), 9, _hoisted_21)
                      ]),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.$t(`type.application.${item.type}`)), 1),
                      _createElementVNode("td", _hoisted_23, [
                        _createVNode(TimeShow, {
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", _hoisted_24, [
                        _createVNode(_component_el_button, {
                          class: "",
                          onClick: ($event: any) => (showApplicationDetails(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.viewDetails")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        (
                  activityTypeKey.value === 'wholesale' &&
                  criteria.value.status == TabStatus.Rejected
                )
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              onClick: ($event: any) => (resetWholesaleApplication(item.partyId))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        (
                  activityTypeKey.value === 'referral' &&
                  criteria.value.status == TabStatus.Rejected
                )
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              onClick: ($event: any) => (openReverseBox(item.id)),
                              type: "warning",
                              class: "ms-3"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("action.restore")), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _createVNode(TableFooter, {
          criteria: criteria.value,
          onPageChange: fetchData
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(ApplicationDetailsPanel, {
      ref_key: "applicationDetailsPanelRef",
      ref: applicationDetailsPanelRef,
      "before-close": handleBeforeClose,
      onSubmit: fetchData
    }, null, 512),
    _createVNode(AccountDetail, {
      ref_key: "accountDetailsPanelRef",
      ref: accountDetailsPanelRef
    }, null, 512),
    _createVNode(wholesaleReferralDetail, {
      ref_key: "wholesaleReferralDetailRef",
      ref: wholesaleReferralDetailRef,
      onSubmit: fetchData
    }, null, 512)
  ], 64))
}
}

})